import { useParams } from 'react-router';
import uppercaseFirstLetter from 'components/Dashboard/utilities/uppercaseFirstLetter';
import ConfigData from 'config/ConfigData';

const useFilterFromType = (props) => {
  const { stakeholderPage } = props;
  const params = useParams();
  const { id } = params;

  const idFilter = [{ field: 'contactIds', value: `${id}`, operator: 'STR_EQ' }];
  const parliamentaryFilters = () => {
    let initialFilter = idFilter;
    let parliamentaryFilter = ConfigData?.parliamentaryFilter || [];
    return initialFilter.concat(parliamentaryFilter);
  };
  const tweetFilter = (id) => {
    return [{ field: stakeholderPage ? 'contactId' : 'screenName', value: `${id}`, operator: 'STR_EQ' }];
  };
  const questionsAnsweredFilters = () => {
    return [
      { field: 'answerByContactId', value: `${id}`, operator: 'STR_EQ' },
      {
        field: 'contentType',
        value: 'QuestionAndAnswer',
        operator: 'str_eq',
      },
      {
        field: 'contentType',
        value: 'ScotlandQuestionAndAnswer',
        operator: 'str_eq',
      },
      {
        field: 'contentType',
        value: 'WalesQuestionAndAnswer',
        operator: 'str_eq',
      },
      {
        field: 'contentType',
        value: 'NorthernIrelandQuestionAndAnswer',
        operator: 'str_eq',
      },
    ];
  };

  const filterFromType = (type, data) => {
    switch (type) {
      case 'tweet':
        return tweetFilter(data?.id);
      case 'ParliamentaryRecord':
        return parliamentaryFilters();
      case 'WrittenAnswer':
        return questionsAnsweredFilters();
      default:
        return idFilter;
    }
  };

  const changeContentType = (type) => {
    switch (type) {
      case 'key-updates':
        return 'KeyUpdate';
      case 'parliamentary-record':
      case 'spoken-parliamentary-contributions':
      case 'congressional-record-contributions':
        return 'ParliamentaryRecord';
      case 'written-parliamentary-contributions':
        return 'WrittenQuestion';
      case 'tweets':
        return 'tweet';
      case 'answers-to-written-parliamentary-questions':
        return 'WrittenAnswer';
      case 'early-day-motions-as-primary-sponsor-or-supporter':
        return 'EdmPrimaryOrSupported';
      case 'written-parliamentary-contributions-senedd':
        return 'WrittenQuestionSenedd';
      case 'written-parliamentary-contributions-holyrood':
        return 'WrittenQuestionHolyrood';
      case 'written-parliamentary-contributions-stormont':
        return 'WrittenQuestionStormont';
      case 'answers-to-written-parliamentary-questions-senedd':
        return 'WrittenAnswerSenedd';
      case 'answers-to-written-parliamentary-questions-holyrood':
        return 'WrittenAnswerHolyrood';
      case 'answers-to-written-parliamentary-questions-stormont':
        return 'WrittenAnswerStormont';
      default:
        return type;
    }
  };

  const changeContentypeFromUrl = (type) => {
    switch (type) {
      case 'key-updates':
        return 'Key updates ';
      case 'parliamentary-record':
      case 'spoken-parliamentary-contributions':
        return 'Spoken parliamentary contributions ';
      case 'written-parliamentary-contributions':
        return 'Written parliamentary contributions ';
      case 'tweets':
        return 'Tweets ';
      case 'answers-to-written-parliamentary-questions':
        return 'WrittenAnswer';
      case 'early-day-motions-as-primary-sponsor-or-supporter':
        return 'Early Day Motions as primary sponsor or supporter';
      case 'written-parliamentary-contributions-senedd':
        return 'Written parliamentary contributions (Senedd) ';
      case 'written-parliamentary-contributions-holyrood':
        return 'Written parliamentary contributions (Holyrood) ';
      case 'written-parliamentary-contributions-stormont':
        return 'Written parliamentary contributions (Stormont) ';
      case 'answers-to-written-parliamentary-questions-senedd':
        return 'Answers to written parliamentary questions (Senedd) ';
      case 'answers-to-written-parliamentary-questions-holyrood':
        return 'Answers to written parliamentary questions (Holyrood) ';
      case 'answers-to-written-parliamentary-questions-stormont':
        return 'Answers to written parliamentary questions (Stormont) ';
      default:
        return uppercaseFirstLetter(type.replaceAll('-', ' '));
    }
  };

  return { filterFromType, changeContentType, changeContentypeFromUrl };
};

export default useFilterFromType;
